
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import HeroSection from './views/HeroSection/index.vue'
import About from './views/About/index.vue'
import Tongxue from './views/Tongxue/index.vue'
import Activity from './views/Activity/index.vue'
import More from './views/More/index.vue'

@Component({
  components: {
    HeroSection,
    About,
    Tongxue,
    Activity,
    More
  }
})
export default class extends Vue {
  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
